import React from 'react';
import '../../basedata/variables.sass'
import './MobilePagination.sass'
import { useTranslation } from 'react-i18next';
import UserGreeting from '../AppHeader/UserGreeting';

interface MobilePaginationProps {
    activeStep: number;
}

const MobilePagination: React.FC<MobilePaginationProps> = ({ activeStep }) => {
    const { t } = useTranslation();

    
    const rawName = sessionStorage.getItem('name');
    const name = rawName && rawName.trim() !== '' ? rawName : null;

    return (
        <div className="mobile-pagination">
            <div className="progress-indicator">
                {Array.from({length: 6}).map((_, index) => (
                    <div key={index} className={`progress-bar ${index <= activeStep ? 'set-green':'set-gray'}`}></div>
                ))}
            </div>
        </div>
    );
};

export default MobilePagination;